import { AdAnalyticsDailyPerformance, AdAnalyticsFilter } from '@kaizenplatform/hugot-entity';
import gql from 'graphql-tag';
import { List } from 'immutable';

import GraphQLClient from '../../adapter/GraphQLClient';

class AdAnalyticsDailyPerformanceWebApi {
  private readonly graphqlClient: GraphQLClient;
  constructor({ graphqlClient }: { graphqlClient: GraphQLClient }) {
    this.graphqlClient = graphqlClient;
  }

  public getAdAnalyticsDailyPerformance = async ({
    platformKey,
    mediaKey,
    placementKey,
    adVideoIds,
    organizationId,
  }: AdAnalyticsFilter & {
    adVideoIds: string[] | null;
    organizationId?: string;
  }): Promise<List<AdAnalyticsDailyPerformance>> => {
    const result = await this.graphqlClient.query(
      gql`
        query adAnalyticsDailyPerformance(
          $adPlacementKeys: [AdPlacementKey!]!
          $adMediaKeys: [AdMediaKey!]!
          $adPlatformKeys: [AdPlatformKey!]!
          $adVideoIds: [ID!]!
          $organizationId: ID!
        ) {
          adAnalyticsDailyPerformance(
            adPlacementKeys: $adPlacementKeys
            adMediaKeys: $adMediaKeys
            adPlatformKeys: $adPlatformKeys
            adVideoIds: $adVideoIds
            organizationId: $organizationId
          ) {
            adVideoId
            clicks {
              date
              actualValue {
                type
                value
                currency
              }
            }
            impressions {
              date
              actualValue {
                type
                value
                currency
              }
            }
            spend {
              date
              actualValue {
                type
                value
                currency
              }
            }
            mobileAppInstalls {
              date
              actualValue {
                type
                value
                currency
              }
            }
            conversions {
              date
              actualValue {
                type
                value
                currency
              }
            }
            viewThroughConversions {
              date
              actualValue {
                type
                value
                currency
              }
            }
            ctr {
              date
              actualValue {
                type
                value
                currency
              }
            }
            cpc {
              date
              actualValue {
                type
                value
                currency
              }
            }
            cpm {
              date
              actualValue {
                type
                value
                currency
              }
            }
            cpa {
              date
              actualValue {
                type
                value
                currency
              }
            }
            cpaWithViewThroughConversions {
              date
              actualValue {
                type
                value
                currency
              }
            }
          }
        }
      `,
      {
        adPlatformKeys: platformKey !== undefined ? platformKey : [],
        adMediaKeys: mediaKey !== undefined ? mediaKey : [],
        adPlacementKeys: placementKey !== undefined ? placementKey : [],
        adVideoIds: adVideoIds,
        organizationId: organizationId,
      },
    );
    return List(result.adAnalyticsDailyPerformance);
  };
}

export default AdAnalyticsDailyPerformanceWebApi;
